module.exports = {"id":"189908","name":"Łukasz Skorupski","rating":"76","photo":"./data/images/photos/4/189908.png","club":{"name":"AS Rome","logo":"./data/images/clubs/ASRome.png"},"positions":["G"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/ŁukaszSkorupski0.json
// module id = 4481
// module chunks = 0